import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useSendContentMutation } from '../../../services/content_v1';
import { useLazyGetAccountListQuery } from '../../../services/users_v1';
import { extractErrorDetail } from '../../common';
import { Modal } from '../Modal';
import MultiSelect from '../MultiSelect';
import { SendModalProps } from './types';

export function SendModal({ isOpen, onClose, unitId, unitTitle }: SendModalProps) {
    const [sendUnit] = useSendContentMutation();
    const [success, setSuccess] = useState<boolean>();
    const [fail, setFail] = useState<string>();
    const successClass = 'popup_message';
    const [accounts, setUsers] = useState<string[]>([]);
    const [availUsers, setAvailUsers] = useState<{ value: number; label: string; }[]>([]);
    const [fetchSubscribers, { data: subscribers }] = useLazyGetAccountListQuery({});

    useEffect(() => {
        if (isOpen) {
            fetchSubscribers({ offset: 0, limit: -1 });
            setSuccess(false);
            setFail('');
            setUsers([]);
        }
    }, [isOpen]);

    useEffect(() => {
        if (subscribers) {
            setAvailUsers(subscribers.results.data.map(s => ({ value: s.id, label: s.name })));
        }
    }, [subscribers]);

    return (
        <Modal className={success ? successClass : 'popup_send'} isOpen={isOpen} onClose={() => onClose()}>
            {success ?
                <div className="form-message _success">
                    <div className="form-message__icon"></div>
                    <h2 className="popup__heading form-message__heading">
                        <Trans>modal:CONTENT_SENT</Trans>
                    </h2>
                    <div className="form-message__copy">
                        <Trans>modal:CONTENT_SENT_SUCCESS_MESSAGE</Trans>
                    </div>
                    <div className="form-message__ok">
                        <span className="btn" onClick={() => onClose()}>
                            <Trans>modal:SUCCESS_MESSAGE_CONFIRM</Trans>
                        </span>
                    </div>
                </div>
                :
                (fail
                    ?
                    <div className="form-message _error">
                        <div className="form-message__icon"></div>
                        <h2 className="popup__heading form-message__heading">
                            <Trans>modal:ERROR_MESSAGE_TITLE</Trans></h2>
                        <div className="form-message__copy">
                            {fail}
                        </div>
                        <div className="form-message__ok">
                            <span className="btn" onClick={() => onClose()}>
                                <Trans>modal:ERROR_MESSAGE_CONFIRM</Trans>
                            </span>
                        </div>
                    </div>
                    :
                    <div className="content-add__send">
                        <h1 className="content-add__send-heading">
                            <Trans>modal:REQUEST_DISPATCH</Trans>
                        </h1>
                        <p className="content-add__send-copy">
                            <Trans>modal:CONTENT_SENT_SELECT_CUSTOMERS</Trans> → <strong>{unitTitle}</strong>
                        </p>
                        <MultiSelect
                            className="form__item"
                            placeholder={t('modal:CONTENT_SENT_SELECT_PLACEHOLDER')}
                            value={accounts}
                            options={availUsers}
                            setValue={(v) => setUsers(v)}
                        />
                        <div className="content-add__send-submit">
                            <span className={'btn' + (accounts.length === 0 ? ' _disabled' : '')} onClick={() => {
                                sendUnit({ id: unitId, accounts: accounts }).unwrap().then(() => {
                                    setSuccess(true);
                                }).catch((e) => {
                                    setFail(extractErrorDetail(e));
                                });
                            }}><Trans>Send</Trans></span>
                        </div>
                    </div>
                )
            }
        </Modal >
    );
}

